/**
 * AP · Cart line groups (2026-08-16, user): Shopify tách line khi BxGy phân bổ; Liquid
 * (cart-products) gộp hiển thị thành nhóm TRẢ TIỀN + nhóm FREE. File này xử lý +/−/xoá cho
 * nhóm có >1 line (Horizon mặc định chỉ biết 1 line):
 *   +   → /cart/add.js variant (cùng properties)  → Shopify tự phân bổ lại
 *   −   → /cart/change.js line cuối của nhóm, qty−1
 *   xoá → /cart/update.js đưa mọi key trong nhóm về 0
 * Sau đó bắn shopify:cart:lines-update (promise sections rỗng) để Horizon re-render drawer/cart.
 */
(function () {
  'use strict';
  if (window.__apCartMerge) return; window.__apCartMerge = true;
  function refresh() {
    var ev = new CustomEvent('shopify:cart:lines-update', { bubbles: true });
    ev.promise = Promise.resolve({ detail: {} });
    document.dispatchEvent(ev);
  }
  function post(url, body) {
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) });
  }
  var busy = false;
  // window capture: chạy TRƯỚC listener document-capture của Horizon (đăng ký sớm hơn) → chặn double-fire
  window.addEventListener('click', function (e) {
    var t = e.target; if (!t || !t.closest) return;
    var row = t.closest('tr[data-ap-group-lines]'); if (!row) return;
    var lines = parseInt(row.getAttribute('data-ap-group-lines'), 10) || 1;
    if (lines < 2) return; // nhóm 1 line → Horizon lo
    var plus = t.closest('button[name="plus"]'), minus = t.closest('button[name="minus"]'), rm = t.closest('.cart-items__remove');
    if (!plus && !minus && !rm) return;
    e.preventDefault(); e.stopImmediatePropagation();
    if (busy) return; busy = true;
    row.classList.add('ap-row-busy');
    var keys = (row.getAttribute('data-ap-group-keys') || '').split(',').filter(Boolean);
    var variant = parseInt(row.getAttribute('data-ap-variant'), 10);
    var props = {}; try { props = JSON.parse(row.getAttribute('data-ap-props') || '{}') || {}; } catch (_) {}
    if (Array.isArray(props)) { var o = {}; props.forEach(function (pr) { if (pr && pr.length === 2) o[pr[0]] = pr[1]; }); props = o; } // Liquid | json của properties = mảng cặp
    var p;
    if (plus) {
      var body = { id: variant, quantity: 1 };
      if (props && Object.keys(props).length) body.properties = props;
      p = post('/cart/add.js', body);
    } else if (minus) {
      p = fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
        var last = null;
        (cart.items || []).forEach(function (it) { if (keys.indexOf(it.key) !== -1) last = it; });
        if (!last) return null;
        return post('/cart/change.js', { id: last.key, quantity: Math.max(0, last.quantity - 1) });
      });
    } else {
      var updates = {}; keys.forEach(function (k) { updates[k] = 0; });
      p = post('/cart/update.js', { updates: updates });
    }
    Promise.resolve(p).catch(function () {}).then(function () { busy = false; row.classList.remove('ap-row-busy'); refresh(); });
  }, true);
})();
